export function removeSequenceWithoutGene(rawDataCollection) {
  const {
    rawAlignments,
    rawSequenceMap,
    rawSequences,
  } = rawDataCollection;

  const removedAlignments = rawAlignments.filter((aligned) => {
    if (aligned.geneSequences.length === 0) {
      return true;
    } else {
      return false;
    }
  });

  const removedAlignmentUUIDs = new Set(removedAlignments.map((aligned) => {
    return aligned.uuid;
  }));

  const removedSequence = removedAlignments.map((aligned) => {
    const {rawSequenceUuid} = aligned;
    const rawSequence = rawSequenceMap[rawSequenceUuid];

    return rawSequence;
  });

  const removedSequenceUUIDs = new Set(removedSequence.map((seq) => {
    return seq.uuid;
  }));

  rawDataCollection.rawAlignments = rawAlignments.filter((aligned) => {
    return !(removedAlignmentUUIDs.has(aligned.uuid));
  });

  rawDataCollection.rawSequences = rawSequences.filter((seq) => {
    return !(removedSequenceUUIDs.has(seq.uuid));
  });

  return rawDataCollection;
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/alignment/index.js